// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ukU3HOx5L_51R6F69UxW{margin:0}`, "",{"version":3,"sources":["webpack://./../../components/react/src/components/GeneralErrorModal/generalErrorModal.module.scss"],"names":[],"mappings":"AAAA,sBACE,QAAA","sourcesContent":[".bodyTextValue {\n  margin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bodyTextValue": `ukU3HOx5L_51R6F69UxW`
};
export default ___CSS_LOADER_EXPORT___;
